import React, { useEffect, useState, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import uuid from 'react-uuid';
import Form from 'react-bootstrap/Form';
import Typography from '@mui/material/Typography';
import { Divider } from '@mui/material';
import FormControl from 'react-bootstrap/FormControl'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import { LocalizationContext } from '../App';
import NavLink from 'react-bootstrap/NavLink';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ReactSession } from 'react-client-session';
import { useNavigate } from 'react-router-dom';
import { RadioButtonComponent } from '@syncfusion/ej2-react-buttons';
import Container from 'react-bootstrap/Container'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import TextField from "@mui/material/TextField";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { inputLabelClasses } from "@mui/material/InputLabel";
import { styled } from "@mui/material/styles";
import { useBeforeunload } from 'react-beforeunload';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import LinearProgress from '@mui/material/LinearProgress';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Backdrop from '@mui/material/Backdrop';
import Pagination from '@mui/material/Pagination';
import { useMediaQuery } from 'react-responsive';
import cloneDeep from 'lodash/cloneDeep';
import LoupeValidationEngine from './LoupeValidationEngine';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoupeActivityItem from './ActivityItemComponents/LoupeActivityItem';

import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const LoupeActivityContent = props => {

    ReactSession.setStoreType("localStorage");
    const useridvalue = ReactSession.get("userid");
    
    const enableUpload = ( process.env.REACT_APP_ENABLE_UPLOAD == "TRUE" ) ? true : false;
    const enableDeferredUpload = ( process.env.REACT_APP_ENABLE_DEFERRED_UPLOAD == "TRUE" ) ? true : false;
    
    const location = useLocation();

    const isMobileView = useMediaQuery({        
        query: '(max-width: 900px)'
    })

    const localizer = LocalizationContext.Consumer._currentValue;

    const navigate = useNavigate();
    const template = () => null;
    const { language, activityCode } = useParams();

    const currentActivity = location.state?.activity;

    const [ showAlert, setShowAlert ] = React.useState(false);
    const [ backConfirmed, setBackConfirmed ] = React.useState(false);
    const [ isUploading, setIsUploading ] = React.useState(false);

    useEffect(() => {
        window.history.pushState(null, null, window.location.pathname);        
        window.addEventListener('popstate', onBackButtonEvent);
        return () => window.removeEventListener('popstate', onBackButtonEvent);
    }, []);

    const onBackButtonEvent = (event) => {
        event.preventDefault();
        if( !backConfirmed ) {
            setShowAlert(true);
        } 
    }

    const cancelBack = () => {
        window.history.pushState(null,null,window.location.pathname);
        setBackConfirmed(false);
        setShowAlert(false);
    }

    const confirmBack = () => {
        setBackConfirmed(true);
        setShowAlert(false);
        navigate("/", { replace : true });
    }

    const contentItems = useRef(new Object());
    const [ showValidationError, setShowValidationError ] = useState(false);

    const [ contentTemplate, setContentTemplate ] = useState(template);
    const [ activityItems, setActivityItems ] = useState(template);
    const [ pagedItems, setPagedItems ] = useState(new Object());

    const [ maxPages, setMaxPages ] = useState(1);
    const [ currentPage, setCurrentPage ] = useState(1);
    
    const handlePaginationChange = (event, value) => {
         
        setCurrentPage(value);
        window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
    };

    const [locationKeys, setLocationKeys] = useState([]);


    const validateActivityItems = () => {

        var firstPageWithError = false;
        var isValid = true;

        activityItems.forEach(i => {
            var tmpVal = i.validator.isValid();
            if(!tmpVal) {
                isValid = false;
                if(!firstPageWithError) {
                    firstPageWithError = i.page;
                }
            }

        });

        return { result : isValid, firstError : firstPageWithError };

    }

    const readResultFromActivityItem = (i) => {

        // only process the current item if we have a meaningful way to store data, i.e., exportlabel
        if(i.exportLabel && i.exportLabel != ""){

            var currentResult = {};
            currentResult["variable"] = i.exportLabel;
            currentResult["responses"] = new Array();
            currentResult['othervalue'] = i.otherValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/'/g, '\\"');

            if(i.type == "text") {               
                currentResult["responses"].push(i.selectedValue.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/'/g, '\\"'));
            }

            if(i.type == "numeric-range" ) {
                var rangeResult = {};
                rangeResult.from = i.selectedValues[0];
                rangeResult.to = i.selectedValues[1];
                currentResult["responses"].push(rangeResult);

            }

            if(i.type == "selection") {
                currentResult["responses"].push(i.selectedValue);
            }

            if(i.type == "chips") { 
                i.selectedValues && i.selectedValues.forEach(c => {
                    currentResult["responses"].push(c);
                }); 
            }

            if(i.type == "chip-conditional-likert" || i.type == "chip-conditional-slider") {
                i.selectedValues && i.selectedValues.forEach(c => {
                    // for each selected chip, obtain the corresponding likert rating and save it together in the response
                    var tmpResponse = new Array();
                    // push selected value
                    tmpResponse.push(c);
                    // obtain corresponding rating
                    var selectedItemIdx = i.itemOrder.indexOf(c);  
                    tmpResponse.push(i.scales[selectedItemIdx].selectedValue);
                    currentResult["responses"].push(tmpResponse);
                });
            }       
            
            if(i.type == "chip-conditional-chips" ) {
                i.selectedValues && i.selectedValues.forEach(c => {
                    // for each selected chip, obtain the corresponding explanations
                    var tmpResponse = new Array();
                    // push selected value
                    tmpResponse.push(c);
                    // obtain corresponding rating
                    var selectedItemIdx = i.itemOrder.indexOf(c);  
                    tmpResponse.push(i.scales[selectedItemIdx].selectedExplanations);
                    tmpResponse.push(  { othervalue : i.scales[selectedItemIdx].getOtherValue().replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/'/g, '\\"') } );
                    currentResult["responses"].push(tmpResponse);
                });
            }       

            if(i.type == "likert-selection") {
                currentResult["responses"].push(i.selectedValue);
            }

            if(i.type == "likert-slider") {
                currentResult["responses"].push(i.selectedValue);
            }

            
            if(i.type == "likert-multiselection") {
                
                var tmp = new Array();
                i.scales.forEach(k => {
                    var cRes = {}
                    cRes['variable'] = k.exportLabel;
                    cRes['responses'] = new Array();
                    cRes['responses'].push( k.selectedValue );
                    
                    tmp.push(cRes);
                });
                currentResult['responses'] = tmp;
            }


            if(i.type == "camera-image") {
                currentResult["responses"].push(i.selectedValue);
            }

            if(i.type == "simple-map" || i.type == "draggable-map") {                    

                i.selectedValues && i.selectedValues.forEach(m => {

                    if( i.hasMarkerItems == false ) {                            
                        
                        delete m.markeritems; // this key is not needed in resultset
                        currentResult["responses"].push(m);
                    
                    } else {

                        var tmpSet = {};
                        tmpSet["variables"] = new Array();

                        m.markeritems.forEach(mi => {
                            var currentResult = readResultFromActivityItem(mi);
                            if( currentResult !== null ) {
                                tmpSet["variables"].push(currentResult);
                            }
                        });

                        m.markeritems = tmpSet;
                        currentResult['responses'].push(m);

                    }
                                            
                });


            }

            return currentResult;
            
            
        } else {

            return null;

        }

    }

    const saveResultToLocalStorage = (resultSet, uri) => {                

        var previousSessions = JSON.parse(ReactSession.get("prevSessionStore"));        
        
        if( previousSessions.hasOwnProperty(currentActivity.sessionId)) {
            console.log("already within previous session data - not saved again");
        } else {
            var storeObj = { uri : uri, result : resultSet, key : currentActivity.sessionId };
            previousSessions[currentActivity.sessionId] = JSON.stringify(storeObj);
        }   
        ReactSession.set("prevSessionStore", JSON.stringify(previousSessions));             
        navigate('/activity-complete', { replace : true, state : { activity : currentActivity } });

    }

    const addCompletedActivityToUserHistory = () => {

        var previousSessions = JSON.parse(ReactSession.get("userHistory"));       
        
        if( previousSessions.hasOwnProperty(currentActivity.sessionId)) {
            console.log("already within previous history data - not saved again");
        } else {
            var storeObj = { activity : currentActivity };
            previousSessions[currentActivity.sessionId] = JSON.stringify(storeObj);
        }   
        ReactSession.set("userHistory", JSON.stringify(previousSessions));    
    }

    const submitFormAndFinish = (uploadImmediately) => {
         
        setIsUploading(true);

        // copy over content into a temporary stored object, to be able to go back
        var backupOfVariableValues = cloneDeep(activityItems);
        
        var validated = validateActivityItems();

        if(! validated.result ) {

            setCurrentPage( validated.firstError);
            window.scrollTo({
                top: 0,
                behavior: "smooth"
              });
            setShowValidationError(true);
            setIsUploading(false);

            return;
        }

        
        var defaultNodataValue = contentTemplate['activityTemplate']['_attributes']['default-nodata-value'];        
        
        var resultSet = {};
        resultSet["variables"] = new Array();
        resultSet["geolocation"] = new Array();

        resultSet["source"] = new Array();
        resultSet["source"].push( currentActivity.source );

        // save some metadata within the resultset
        // overwrite with activity metadata user location if any
        if( currentActivity.latitude !== undefined && currentActivity.longitude !== undefined ) {            
            var coords = {}
            coords.latitude = currentActivity.latitude;
            coords.longitude = currentActivity.longitude;
            coords.accuracy = (currentActivity.accuracy !== undefined) ? currentActivity.accuracy : -1;
            resultSet["geolocation"].push(coords);
        }  

        // save to local history
        currentActivity.timeCompleted = new Date();
        addCompletedActivityToUserHistory();      

        activityItems.forEach(i => {        
            var currentResult = readResultFromActivityItem(i);
            if( currentResult !== null ) {
                resultSet["variables"].push(currentResult);
            }            
        });

        if( !enableUpload ) {
            console.log(resultSet);
            setIsUploading(false);
            return;
        }          
                
        // post results
        const headers = {
            "Content-Type": "application/x-www-form-urlencoded",
            'LOUPE-USR-KEY' : useridvalue,
            'LOUPE-API-KEY' : 'APIKEY2',
        };


        let uri = process.env.REACT_APP_SERVICE_URI + '/api/putResponse/' + language + '/' + activityCode;
        if( enableUpload && uploadImmediately) {

            axios.post(uri, resultSet, { headers }).then(
                res => {                 
                    
                    // add error catching routine
                    if(res.data == "200") {                    
                        navigate('/activity-complete', { replace : true, state : { activity : currentActivity } });
                    } else {
                        alert("Ups. Something went wrong.");
                    }

            }).catch(error => {
                alert(error);
                console.log(error);
                saveResultToLocalStorage(resultSet, uri);
            });            
        } else {
            // test here local storage or sth to not loosing any results
            // note that this should also only happen if upload shall take place after all
            if(enableUpload) {
                saveResultToLocalStorage(resultSet, uri);
            }
        }
        
    }

    

   
    const parseXmlItem = (i, currentPage, currentActivity) => {

        // create new item element that is returned to be pushed to list
        var currentItem = {      
            selectedValue : "", 
            selectedValues : new Array(),   
            otherValue : "",                            
            id : uuid(),  
            page : currentPage,
            type : i['_attributes']['item-type'],
            choices : i['choice'] ? i['choice'] : null,              
            label : i['_attributes']['label'] ? i['_attributes']['label'] : "", 
            body : i['_attributes']['body-text'] ? i['_attributes']['body-text'] : "", 
            exportLabel : i['_attributes']['export-label'] ? i['_attributes']['export-label'] : "",   
            required : i['_attributes']['required'] ? (i['_attributes']['required'] == 'true' ? true : false ) : false,                        
        };


        currentItem.getValue = () => {
            if(currentItem.type == "draggable-map" || currentItem.type == "simple-map" || currentItem.type == "chips" ) {
                return currentItem.selectedValues;
            } else {
                return currentItem.selectedValue;
            }
        }

        currentItem.rules = new Array();
        if( i['validate'] ) {

            if(Array.isArray( i['validate']))
            {
                i['validate'].forEach(m => {

                    var ruleName = m['_attributes']['rule'];
                    var ruleValue = "";

                    if( ruleName == "maxLength" || ruleName == "minLength" || ruleName == "minElements" || ruleName == "maxElements" ){
                        ruleValue = parseInt(m['_attributes']['value']);
                    }

                    currentItem.rules.push({ rule : ruleName, value : ruleValue });
                })

            } else {

                var m = i['validate'];
                var ruleName = m['_attributes']['rule'];
                var ruleValue = "";

                if( ruleName == "maxLength" || ruleName == "minLength" || ruleName == "minElements" || ruleName == "maxElements" ){
                    ruleValue = parseInt(m['_attributes']['value']);
                }

                currentItem.rules.push({ rule : ruleName, value : ruleValue });

            }  
        }

        if( currentItem.type == "text" ) {
            currentItem['boxPrompt'] = i['_attributes']['box-prompt'] ? i['_attributes']['box-prompt'] : "";
        }

        if( currentItem.type == "chip-conditional-slider" ) {
            // choices are automatically read, corresponding to Chips selection
            // in addition to choices, determine common slider properties
            currentItem['minLabel'] = i['_attributes']['min-label'] ? i['_attributes']['min-label'] : null;
            currentItem['maxLabel'] = i['_attributes']['max-label'] ? i['_attributes']['max-label'] : null;                        
            currentItem['sliderType'] = i['_attributes']['slider-type'] ? i['_attributes']['slider-type'] : 'continuous';
            
            currentItem.minValue = i['_attributes']['min-value'] ? parseInt(i['_attributes']['min-value']) : 0;
            currentItem.maxValue = i['_attributes']['max-value'] ? parseInt(i['_attributes']['max-value']) : 100;
            
            if( currentItem.sliderType == "discrete") {
                currentItem.increment = i['_attributes']['increment'] ? parseInt(i['_attributes']['increment']) : 1;
            }

            currentItem.marks = new Array();
            currentItem.marks.push( { value : currentItem.minValue, label : currentItem.minLabel } );
            currentItem.lockMarks = i['_attributes']['lock-steps'] ? ( i['_attributes']['lock-steps'] == 'true' ? true : false ) : false;
            currentItem.marks.push( { value : currentItem.maxValue, label : currentItem.maxLabel } );
            

            // initial value selection based on template or default value
            currentItem.selectedValue = i['_attributes']['initial-value'] ? parseInt(i['_attributes']['initial-value']) : 0;
            
            currentItem.itemOrder = new Array();
            currentItem.scales = new Array();

            // generally, for each choice (chip), we require a value to be stored
            // and consequently, a delegate to update this value when the according slider
            // is changed to a new value

            i['choice'].forEach(o => {
                
                var newChoice = { 
                    id : uuid() + "_" + currentItem.id + "_" + o['_attributes']['export-label'],
                    unitItems : [],                 
                    selectedValue : "",
                    label : o['_attributes']['label'],
                    exportLabel : o['_attributes']['export-label']
                };

                currentItem.itemOrder.push(o['_attributes']['export-label']);
                
                newChoice.setValue = (value) => {
                    newChoice.selectedValue = value;
                };

                currentItem.scales.push(newChoice);
            })

        }

        if( currentItem.type == "chip-conditional-likert" ) {
            // choices are automatically read, corresponding to Chips selection
            // in addition to choices, a common scale must be created
            currentItem['minLabel'] = i['_attributes']['min-label'] ? i['_attributes']['min-label'] : null;
            currentItem['maxLabel'] = i['_attributes']['max-label'] ? i['_attributes']['max-label'] : null;            
            currentItem['includeNa'] = "false";
            
            currentItem['units'] = i['_attributes']['units'] ? parseInt(i['_attributes']['units']) : 0;        
            
            currentItem['unitItems'] = new Array();
            currentItem.itemOrder = new Array();
            currentItem.scales = new Array();
            



            // unitItems holds a set of choice objects, each of which has units and a value delegate handler
            i['choice'].forEach(o => {
                
                var newChoice = { 
                    id : uuid() + "_" + currentItem.id + "_" + o['_attributes']['export-label'],
                    unitItems : [],                 
                    selectedValue : "",
                    label : o['_attributes']['label'],
                    exportLabel : o['_attributes']['export-label']
                };

                currentItem.itemOrder.push(o['_attributes']['export-label']);
                
                newChoice.setValue = (value) => {
                    newChoice.selectedValue = value;
                };

                
                // rewire this part to either use numeric or pre-defined scales
                if( currentItem.units > 0 ) {
                    
                    for(var n = 0; n < currentItem.units; n++) {                            
                        let currentUnit = {                            
                            value : String((n + 1)),
                            label : String((n + 1)),
                            id : "unit_" + n + "_" + newChoice.id,
                            parent : o
                        };
                        newChoice.unitItems.push(currentUnit);                        
                    }
                    currentItem.scales.push(newChoice);

                } else {


                    // in this context, disable min-label/max-label
                    currentItem.minLabel = "";
                    currentItem.maxLabel = "";

                    i['scale'].forEach(o => {
                        let currentUnit = {   
                            value : o['_attributes']['export-label'],
                            label : o['_attributes']['label'],
                            id : "unit_" + uuid() + "_" + currentItem.id,
                            parent : currentItem
                        };
                        newChoice.unitItems.push(currentUnit);       
                    });

                    currentItem.scales.push(newChoice);

                }                    
            });
            
        }


        if( currentItem.type == "chip-conditional-chips" ) {
            // choices are automatically read, corresponding to Chips selection
            // in addition to choices, a common scale must be created
            currentItem.itemOrder = new Array();
            currentItem.scales = new Array();
            
            // unitItems holds a set of choice objects, each of which has units and a value delegate handler
            i['choice'].forEach(o => {
                
                var newChoice = { 
                    id : uuid() + "_" + currentItem.id + "_" + o['_attributes']['export-label'],
                    unitItems : [],
                    otherValue : "",
                    selectedExplanations : [],                 
                    label : o['_attributes']['label'],
                    exportLabel : o['_attributes']['export-label'],
                    enableOtherValueField : o['_attributes']['enable-other'] ? o['_attributes']['enable-other'] : 'false',
                    showOtherValueField : false
                };

                currentItem.itemOrder.push(o['_attributes']['export-label']);
                  

                newChoice.setShowOtherField = (value) => {
                    newChoice.showOtherValueField = value;
                }

                newChoice.setValue = (value) => {
                    newChoice.selectedValue = value;
                };

                newChoice.setOtherValue = (value) => {
                    newChoice.otherValue = value;
                }
                newChoice.getOtherValue = () => {
                    return newChoice.otherValue;
                }

                newChoice.hasExplanation = (value) => {
                    return newChoice.selectedExplanations.includes(value);
                }

                newChoice.clearSelection = () => {
                    newChoice.selectedExplanations = [];
                    newChoice.otherValue = "";
                }
                            
                newChoice.handleExplanationClick = (chipValue, item) => {
                    if(newChoice.hasExplanation(chipValue)) {
                        var idx = newChoice.selectedExplanations.indexOf(chipValue);
                        newChoice.selectedExplanations.splice(idx, 1);                                           
                    } else {
                        newChoice.selectedExplanations.push(chipValue);
                    }            
                }

                
                // here, determine which chips to use per item
                o['explain'].forEach(exp => {
                    newChoice.unitItems.push( 
                        { 
                            id : uuid(),                        
                            label : exp['_attributes']['label'],
                            exportLabel : exp['_attributes']['export-label']
                        });
                });
                
                currentItem.scales.push(newChoice);
            });
            
        }

        if( currentItem.type == "numeric-range" ) {
            currentItem['minValue'] = i['_attributes']['min-value'] ? parseInt(i['_attributes']['min-value']) : 0;
            currentItem['maxValue'] = i['_attributes']['max-value'] ? parseInt(i['_attributes']['max-value']) : 10; 
            
            currentItem.scales = new Array();
            for (let sval = currentItem.minValue; sval <= currentItem.maxValue; sval++) {
                currentItem.scales.push(sval);
            }
            currentItem.selectedValues = [ currentItem.minValue, currentItem.maxValue];
        }

        if( currentItem.type == "chips" ) {
            currentItem.enableOtherValueField = i['_attributes']['enable-other'] ? i['_attributes']['enable-other'] : "false"; 
        }
        

        if(currentItem.type == "camera-image") {
            currentItem.selectedValue = null
        }

        if( currentItem.type == "image" ) {
            currentItem.imageSource = i['_attributes']['image-source'];
            currentItem.caption = i['_attributes']['caption'] ? i['_attributes']['caption'] : "";
        }
       

        if(currentItem.type == "simple-map" || currentItem.type == "draggable-map" ) {

            currentItem.mapHeight = i['_attributes']['map-height'] ? i['_attributes']['map-height'] : "450px";
            
            currentItem.forceExtent = i['_attributes']['force-extent'] ? i['_attributes']['force-extent'] : "false";
            currentItem.centerLatitude = i['_attributes']['map-center'] ? parseFloat(i['_attributes']['map-center'].split(',')[0]) : null;
            currentItem.centerLongitude = i['_attributes']['map-center'] ? parseFloat(i['_attributes']['map-center'].split(',')[1]) : null;
            currentItem.mapZoom = i['_attributes']['map-zoom'] ? parseInt(i['_attributes']['map-zoom']) : null;
            
            currentItem.hasMarkerItems = false;
            currentItem.markerItems = [];

            // overwrite with activity metadata user location if any            
            if( (currentActivity.latitude !== undefined && currentActivity.latitude !== null) && currentItem.forceExtent == "false" )
            {
                currentItem.centerLatitude = currentActivity.latitude;
            }
            if( (currentActivity.longitude !== undefined && currentActivity.latitude !== null) && currentItem.forceExtent == "false" )
            {
                currentItem.centerLongitude = currentActivity.longitude;
            }

            currentItem.markerStyle = i['_attributes']['marker-style'] ? i['_attributes']['marker-style'] : "";
            currentItem.markerLimit = i['_attributes']['marker-limit'] ? parseInt(i['_attributes']['marker-limit']) : -1;

            currentItem['markers'] = [];
            currentItem['obj'] = null;

            if(currentItem.type == "draggable-map") {
                currentItem.markerTypes = i['choice'] ? i['choice'] : null;
                currentItem['selectedMarker'] = "none";
            }

            
            if(i['marker-items']) {

                // marker items is never going to be an array but we need to see how we get to an array
                currentItem.hasMarkerItems = true;

                var m = i['marker-items']; 
                if(Array.isArray( m['item'] )) {
                                                            
                    m['item'].forEach(r => {
                        var mItem = parseXmlItem(r, 1, currentActivity);
                        currentItem.markerItems.push(mItem); 
                    })

                } else {

                    var r = m['item'];
                    var mItem = parseXmlItem(r, 1, currentActivity);
                    currentItem.markerItems.push(mItem);
                }                                                             
            }
        }


        if( currentItem.type == "likert-selection" || currentItem.type == "likert-multiselection" ) {                                        

            currentItem['minLabel'] = i['_attributes']['min-label'] ? i['_attributes']['min-label'] : null;
            currentItem['maxLabel'] = i['_attributes']['max-label'] ? i['_attributes']['max-label'] : null;            
            currentItem['includeNa'] = i['_attributes']['include-not-applicable'] ? i['_attributes']['include-not-applicable'] : "false";
            currentItem['definedNa'] = i['_attributes']['defined-not-applicable'] ? i['_attributes']['defined-not-applicable'] : "";

            
            currentItem['units'] = i['_attributes']['units'] ? parseInt(i['_attributes']['units']) : 0;               
            currentItem['unitItems'] = new Array();
            
            // either specify unit items, or use pre-defined choice elements
            

            if( currentItem.type == "likert-selection" ) {

                // use numeric unit lettering dependent on the number of units specified to be used 
                if( currentItem.units > 0 ) {
                    for(var n = 0; n < currentItem.units; n++) {                            
                        let currentUnit = {                            
                            value : String((n + 1)),
                            label : String((n + 1)),
                            id : "unit_" + n + "_" + currentItem.id,
                            parent : currentItem
                        };
                        currentItem.unitItems.push(currentUnit);                        
                    }
                } else {
                    // only if no units are specified (this needs to be taken care manually in xml specification currently),
                    // use pre-defined scale element to label radio buttons

                    // in this context, disable min-label/max-label
                    currentItem.minLabel = "";
                    currentItem.maxLabel = "";

                    i['scale'].forEach(o => {
                        var currentId = uuid();

                        let currentUnit = {                            
                            value : o['_attributes']['export-label'],
                            label : o['_attributes']['label'],
                            id : "unit_" + currentId + "_" + currentItem.id,
                            parent : currentItem
                        };
                        currentItem.unitItems.push(currentUnit);       
                    });
                }
                
            }

            if( currentItem.type == "likert-multiselection" ) {

                currentItem.scales = [];

                // in this, unitItems holds a set of choice objects, each of which has units and a value delegate handler
                i['choice'].forEach(o => {
                    var newChoice = { 
                        id : uuid() + "_" + currentItem.id + "_" + o['_attributes']['export-label'],
                        unitItems : [],                 
                        selectedValue : "",
                        label : o['_attributes']['label'],
                        exportLabel : o['_attributes']['export-label']
                    };
                    
                    newChoice.setValue = (value) => {
                        newChoice.selectedValue = value;
                    };

                    
                    // rewire this part to either use numeric or pre-defined scales
                    if( currentItem.units > 0 ) {
                        
                        for(var n = 0; n < currentItem.units; n++) {                            
                            let currentUnit = {                            
                                value : String((n + 1)),
                                label : String((n + 1)),
                                id : "unit_" + n + "_" + newChoice.id,
                                parent : o
                            };
                            newChoice.unitItems.push(currentUnit);                        
                        }
                        currentItem.scales.push(newChoice);

                    } else {

                        // in this context, disable min-label/max-label
                        currentItem.minLabel = "";
                        currentItem.maxLabel = "";

                        i['scale'].forEach(o => {
                            let currentUnit = {   
                                value : o['_attributes']['export-label'],
                                label : o['_attributes']['label'],
                                id : "unit_" + uuid() + "_" + currentItem.id,
                                parent : currentItem
                            };
                            newChoice.unitItems.push(currentUnit);       
                        });

                        currentItem.scales.push(newChoice);

                    }                    
                });
            }
        } 
        
        if( currentItem.type == "likert-slider" ) {                                        
            
            currentItem['minLabel'] = i['_attributes']['min-label'] ? i['_attributes']['min-label'] : null;
            currentItem['maxLabel'] = i['_attributes']['max-label'] ? i['_attributes']['max-label'] : null;
            currentItem['sliderType'] = i['_attributes']['slider-type'] ? i['_attributes']['slider-type'] : 'continuous';
            
            currentItem.minValue = i['_attributes']['min-value'] ? parseInt(i['_attributes']['min-value']) : 0;
            currentItem.maxValue = i['_attributes']['max-value'] ? parseInt(i['_attributes']['max-value']) : 100;
            
            if( currentItem.sliderType == "discrete") {
                currentItem.increment = i['_attributes']['increment'] ? parseInt(i['_attributes']['increment']) : 1;
            }

            currentItem.marks = new Array();
            currentItem.marks.push( { value : currentItem.minValue, label : currentItem.minLabel } );
            currentItem.lockMarks = i['_attributes']['lock-steps'] ? ( i['_attributes']['lock-steps'] == 'true' ? true : false ) : false;
            
            if(i['mark']) {

                if(Array.isArray( i['mark']))
                {
                    i['mark'].forEach(m => {
                        currentItem.marks.push({ value : parseInt(m['_attributes']['value']), label : m['_attributes']['label'] });
                    })

                } else {

                    var m = i['mark'];
                    currentItem.marks.push({ value : parseInt(m['_attributes']['value']), label : m['_attributes']['label'] });
                }                            
            }
            currentItem.marks.push( { value : currentItem.maxValue, label : currentItem.maxLabel } );

            // initial value selection based on template or default value
            currentItem.selectedValue = i['_attributes']['initial-value'] ? parseInt(i['_attributes']['initial-value']) : 0;
            
            // label display property (auto, on, or off)
            currentItem.labelDisplayProperty = i['_attributes']['display-value'] ? i['_attributes']['display-value'] : "auto";
        } 

        currentItem.validator = new LoupeValidationEngine(currentItem);
        if(currentItem.required == false && (currentItem.type == "chips" ||  currentItem.type == "chip-conditional-likert" || currentItem.type == "chip-conditional-slider" || currentItem.type == "chip-conditional-chips")) {
            currentItem.validator.touched();
        }

        // parsing completed. return resulting item
        return currentItem;

    }
    
    
    const parseContext = (i) => {

        var currentContext = {};

        if( i['followup'] ) {
            currentContext['hasFollowUp'] = true;
            currentContext['followupActivity'] = i['followup']['_attributes']['activity-code'] ? i['followup']['_attributes']['activity-code'] : "";
        } else {
            currentContext['hasFollowUp'] = false;
        }

        return currentContext;
    }

    useEffect(() => {

        // make request
        // convert: https://www.npmjs.com/package/xml-js
        axios.get(process.env.REACT_APP_SERVICE_URI + '/api/getActivityContentByCode/' + language + '/' + activityCode, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                'LOUPE-USR-KEY' : ReactSession.get("userid"),
                'LOUPE-API-KEY' : 'APIKEY2',
            }
        }).then(res => { 
            
            var convert = require('xml-js');
            var result1 = convert.xml2json(res.data, { ignoreDeclaration : true, compact: true, spaces: 4});
            result1 = JSON.parse(result1);            
            setContentTemplate(result1);

            var itemList = [];   
            var currentPage = 0;

            var activityContext = result1['activityTemplate']['activityContext'];
            if( activityContext != null || activityContext != undefined )
            {
                currentActivity['context'] = parseContext(activityContext);
            } else {
                currentActivity['context'] = parseContext([]);
            }


            var formPages = result1['activityTemplate']['activityItems']['page'];
            if(!Array.isArray( formPages )) {
                formPages = new Array();
                formPages.push(result1['activityTemplate']['activityItems']['page']);
            }

            formPages.forEach(page => {

                // we need, at minimum, one page
                currentPage += 1;

                var tmp = null;
                
                if(!page['item'].length) {
                    tmp = new Array();
                    tmp.push(page['item']);
                } else {
                    tmp = page['item'];
                }
                
                tmp.forEach(i => {

                    var currentItem = parseXmlItem(i, currentPage, currentActivity);    
                    itemList.push(currentItem);
                    
                });
            });

            setMaxPages(currentPage);
            setActivityItems(itemList);
            

        }).catch(error => {
            console.log(error);
        });

    }, []);

    return(

        <LocalizationContext.Consumer>
        { ({strings}) => 

            <div>            
                 
                
                    
                { activityItems == null ? (

                    <div className="padding">
                        <p>{strings.getString("messages.activity.loading")}</p>
                        <LinearProgress />    
                    </div>

                ) : 
                (

                    <div>

                        <Snackbar open={isUploading} anchorOrigin={{horizontal:'right',vertical:'top'}}>
                            <Alert severity="info" className="text-start">
                               Uploading ...
                            </Alert>
                        </Snackbar>

                        <Dialog open={showValidationError}>  
                            <DialogTitle>{strings.getString("errors.activity.missing.title")}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    {strings.getString("errors.activity.missing.message")}
                                </DialogContentText>
                                <DialogActions>
                                    <Button onClick={() => setShowValidationError(false)}>OK</Button>
                                </DialogActions>
                            </DialogContent>
                        </Dialog>

                        <Backdrop open={showAlert} sx={{color : '#000'}} />
                        <Dialog
                            open={showAlert}                      
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description">
                            
                            <DialogTitle id="alert-dialog-title">
                                {strings.getString("dialogs.activity.cancel.title")}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                {strings.getString("dialogs.activity.cancel.message")}
                                </DialogContentText>                  
                            </DialogContent>

                            <DialogActions>
                                <Button onClick={cancelBack}>{strings.getString("controls.buttons.no")}</Button>
                                <Button onClick={confirmBack}>{strings.getString("controls.buttons.yes")}</Button>
                            </DialogActions>
                            </Dialog>

                        <Form className="mb-7 padding">
                            
                            { activityItems.map(i => {                                 
                                
                                if ( i.page == currentPage ) return(
                                    
                                    <div key={"wrapper_" + i.id} className="mb-5">                                        
                                         <LoupeActivityItem currentItem={i} />
                                    </div>)
                                })

                            }

                        </Form>

                        <div>
                            <Pagination variant="outlined" color="primary" className="container" count={maxPages} page={currentPage} onChange={handlePaginationChange} />
                        </div>

                        { currentPage == maxPages && 
                            <div>
                                <Stack direction="column">
                                    <Button disabled={isUploading} onClick={() => submitFormAndFinish(true)}>{strings.getString("controls.buttons.activity.submit")}</Button>
                                    { enableDeferredUpload &&
                                        <Button  disabled={isUploading} onClick={() => submitFormAndFinish(false)}>{"Speichern und später absenden"}</Button>
                                    }
                                </Stack>
                            </div>
                        }


                    
                    </div>

                )}
               
            </div>
        
        } 
        </LocalizationContext.Consumer>

        


        
    );




}
export default LoupeActivityContent;